import React,{useEffect,useState} from 'react';
import neethuPhoto from '../../assets/images/neethuPhoto.webp'
import { LuHeartHandshake } from "react-icons/lu";
import { FaStar } from "react-icons/fa6";
import googleIcon from '../../assets/images/googleIcon.png'

const Banner = () => {
        const [course, setCourse] = useState('');

        useEffect(() => {
            // Extract query parameters from the URL
            const params = new URLSearchParams(window.location.search);
            const courseParam = params.get('course');
            
            if (courseParam) {
                setCourse(courseParam); // Store the course value from the URL
            }
        }, []); // Runs only once on component mount

        // Log the current course state
        useEffect(() => {
            console.log('Course State:', course);
        }, [course]);

        const handleCourseChange = (event) => {
            setCourse(event.target.value);
        };
    return (
        <>
            <section id='banner'>
                <div className="container">
                    <div className="bannerMain">
                        <div className="bannerThumbnail">
                            <div className="bannerThumbnailBox">
                                <img src={neethuPhoto} alt="" />
                            </div>
                            <div className="bannerLove">
                                <div className="bannerLoveIcon">
                                    <LuHeartHandshake />
                                </div>
                                <p>Train under certified language trainers</p>
                            </div>
                        </div>
                        <div className="bannerDetails">
                            <h4>Trusted by <b>200,000</b> +Students</h4>
                            <h1>India's <span>No.1
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none"><path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7"></path></svg></span> Language Academy</h1>
                            <p>Achieve your dream score with expert guidance</p>
                            <div className="bannerCourse">
                                <ul>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>OET</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>IELTS</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>NCLEX-RN</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>PTE</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>TOEFL</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>GERMAN</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>CBT</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>OSCE</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>TRADING</h3>
                                    </li>
                                    <li>
                                        <div className="icon"></div>
                                        <h3>DIGITAL MARKETING</h3>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="bannerForm">
                                <h2>Let's brighten your future</h2>
                                <form action="">
                                    <div className="formGroup">
                                        <input type="text" placeholder='Name' />
                                    </div>
                                    <div className="formGroup">
                                        <input type="number" placeholder='Phone' />
                                    </div>
                                    <div className="formGroup">
                                        <select value={course} onChange={handleCourseChange}>
                                            <option value="">Select Course</option>
                                            <option value="OET">OET</option>
                                            <option value="IELTS">IELTS</option>
                                            <option value="NCLEX-RN">NCLEX-RN</option>
                                            <option value="PTE">PTE</option>
                                            <option value="TOEFL">TOEFL</option>
                                            <option value="GERMAN">GERMAN</option>
                                            <option value="CBT">CBT</option>
                                            <option value="OSCE">OSCE</option>
                                            <option value="TRADING">TRADING</option>
                                            <option value="DIGITAL MARKETING">DIGITAL MARKETING</option>
                                        </select>
                                    </div>
                                    <div className="formBtnArea">
                                        <button onClick={(e) => {
                                            e.preventDefault();
                                            window.open("tel:+919747944374","_self")
                                        }}>
                                            Get a CallBack
                                        </button>
                                    </div>

                                </form>
                            </div>
                            <div className="bannerReview">
                                <div className="bannerReviewGIcon">
                                    <img src={googleIcon} alt="" />
                                </div>
                                <div className="bannerReviewDetails">
                                    <div className="bannerReviewStar">
                                        <FaStar />
                                        <FaStar />
                                        <FaStar />
                                        <FaStar />
                                        <FaStar />
                                    </div>
                                    <h5>5,583 Google reviews</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Banner;
